<template>
  <div class="login_wrapper">
    <form @submit.prevent="login()">
      <img src="@/assets/logo/studit_blau.svg" />
      <div class="input">
        <label for="username">Benutzername</label>
        <input type="text" v-model="loginForm.username" />
      </div>
      <div class="input">
        <label for="password">Passwort</label>
        <input type="password" v-model="loginForm.password" />
        <span class="error">{{ this.error }}</span>
      </div>
      <div class="input">
        <input type="submit" value="Login" />
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "loginView",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        loginType: "plain",
        rememberMe: true,
      },
      error: "",
    };
  },
  methods: {
    login() {
      axios
        .post("/api/auth/login", this.loginForm)
        .then((res) => {
          if (res.status === 200) {
            this.$router.push("/");
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = "Ungültige Anmeldedaten";
        });
    },
  },
};
</script>

<style scoped>
.login_wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

form {
  min-width: 300px;
  width: 20%;
  display: flex;
  flex-flow: column nowrap;
  padding: 2em;
  border-radius: 1em;
  background: #fff;
}

form img {
  padding-bottom: 2em;
}

.input {
  padding: 1em 0;
  display: flex;
  flex-direction: column;
}

.input label {
  padding: 0;
  margin-bottom: 0.5em;
  color: var(--gray-600);
}

.input input[type="text"],
input[type="password"] {
  padding: 0.5em;
  padding-left: 1em;
  font-size: 1em;
  box-shadow: inset 0px 0px 5px #bababa;
  border: none;
  border-radius: 1em;
}

input[type="submit"] {
  padding: 0.5em 1em;
  font-size: 1em;
  background: var(--secondary-fg);
  color: #fff;
  border: none;
  border-radius: 1em;
  cursor: pointer;
}
</style>
